import React from "react";
import { Provider } from "react-redux";
import jwtDecode from "jwt-decode";
import LocalStorageService from "utils/LocalStorageService";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
    faUser,
    faUsers,
    faUserPlus,
    faUserMinus,
    faIdCard,
    faSearch,
    faHourglassHalf,
    faCog,
    faInfoCircle,
    faPen,
    faMapMarkedAlt,
    faUserTag,
    faEye,
    faPaperPlane,
    faArrowLeft,
    faArrowUp,
    faArrowDown,
    faTrashAlt,
    faPlusSquare,
    faCopy,
    faArrowCircleLeft,
    faArrowCircleRight,
    faTimes,
    faSpinner,
    faRedo,
    faPlus,
    faChevronDown,
    faChevronRight,
    faKey,
    faDownload,
    faStar,
    faCalendarCheck,
    faUserTie,
    faHandshake,
    faThumbsDown,
    faCheckCircle,
    faFilter,
    faExclamation,
} from "@fortawesome/free-solid-svg-icons";

import setAuthToken from "utils/setAuthToken";
import { store, history } from "store";
import PublicRoutes from "router";

import { setCurrentUser, logoutUser } from "actions/authActions";
import packageJson from "../package.json";
import "antd/dist/antd.css";
import "react-table/react-table.css";
import "react-toastify/dist/ReactToastify.css";
import "App.css";

library.add(
    faUser,
    faUserTag,
    faUsers,
    faUserPlus,
    faUserMinus,
    faIdCard,
    faHourglassHalf,
    faSearch,
    faCog,
    faInfoCircle,
    faPen,
    faMapMarkedAlt,
    faEye,
    faPaperPlane,
    faArrowLeft,
    faArrowUp,
    faArrowDown,
    faTrashAlt,
    faPlusSquare,
    faCopy,
    faArrowCircleLeft,
    faArrowCircleRight,
    faTimes,
    faSpinner,
    faRedo,
    faPlus,
    faChevronDown,
    faChevronRight,
    faKey,
    faDownload,
    faStar,
    faCalendarCheck,
    faUserTie,
    faHandshake,
    faThumbsDown,
    faCheckCircle,
    faFilter,
    faExclamation
);

// Check for token
if (localStorage.jwtToken) {
    // Set auth token header auth
    setAuthToken(localStorage.jwtToken);
    // Decode token and get user info and exp
    const decoded = jwtDecode(localStorage.jwtToken);
    // Set user and isAuthenticated
    store.dispatch(setCurrentUser(decoded));

    // Check for expired token
    const currentTime = Math.ceil(Date.now() / 1000);
    if (decoded.exp < currentTime) {
        // Logout user
        store.dispatch(logoutUser());
        // Redirect to login
        window.location.href = "/";
    }
}

if (!localStorage.version) {
    LocalStorageService.setVersion(packageJson.version);
} else if (localStorage.version !== packageJson.version) {
    LocalStorageService.setVersion(packageJson.version);
    window.location.reload(true);
}

const App = () => (
    <Provider store={store}>
        <PublicRoutes history={history} />
    </Provider>
);

export default App;
